const IconPlay = () => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.61729 5.43611L2.80139 2.07172C2.64178 1.98096 2.43229 1.9747 2.26935 2.06233C2.10308 2.14996 2 2.31583 2 2.49422V9.19171C2 9.37011 2.10308 9.53598 2.26602 9.62361C2.34583 9.66429 2.43229 9.6862 2.52207 9.6862C2.6185 9.6862 2.71161 9.66116 2.79474 9.61422L8.61064 6.27799C8.76693 6.19036 8.86336 6.02762 8.86336 5.85862C8.87001 5.68649 8.77358 5.52374 8.61729 5.43611Z"
        fill="#D9DBE0"
      />
    </svg>
  );
};

export default IconPlay;
